import { getBoot } from "@/api/sugGroupDialog";
import { GROUP_ID } from "@/constant/group";
import { useLocation } from "wouter";
import React from "react";
import { Subgroup } from "./subgroup";

export default function SelectTeamPage() {
  const [bootData, setBootData] = React.useState<Moim.Group.IBootstrap>();
  const [, setLocation] = useLocation();
  const getBootData = React.useCallback(async () => {
    const newBootData = await getBoot();
    setBootData(newBootData.data);
  }, [GROUP_ID]);

  React.useEffect(() => {
    getBootData();
  }, [GROUP_ID]);

  return (
    <>
      <Subgroup
        childMoimGroupIds={
          bootData?.group?.sign_up_config_v2?.subgroup?.childMoimGroupIds
        }
        maxCount={bootData?.group?.sign_up_config_v2?.subgroup?.max}
        minCount={bootData?.group?.sign_up_config_v2?.subgroup?.min}
        onNext={() => {
          setLocation("/");
        }}
      />
    </>
  );
}
